var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    _vm.showMsg
      ? _c("div", { attrs: { id: "cookies-warning" } }, [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center align-items-center flex-sm-row flex-column"
            },
            [
              _c("div", [
                _c("p", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.title))
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "small",
                  domProps: { innerHTML: _vm._s(_vm.descr) }
                })
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "mt-sm-0 mt-3",
                  on: {
                    click: function($event) {
                      return _vm.setMsgCookie(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.btn))]
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ce43a0a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ce43a0a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/cookies-msg/cookies-msg.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4ce43a0a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/cookies-msg/cookies-msg.vue
// module chunks = 1